// default imports for react project
import React, { useLayoutEffect } from "react";

// import for dispatching action in react
import { useDispatch } from "react-redux";

// import default style component from react-bootstrap package
import { Col, Container, Row } from "react-bootstrap";

// import function from actions
import { addCrumb } from "store/actions/common";

// Import image from assets folder
import { hollard_white, card_header_img } from "assets/images/images";

// import classname package to combine module css and normal css
import classNames from "classnames";

// import custom data
import { accordion2Data, productDet } from "./data";

// import util to get current window dimensions
import useWindowDimensions from "utils/useWindowDimension";

//   import custom component
import Accordion from "../../components/Accordion";
import { H3Red, H4Grey } from "components/Heading";
import BreadCrumb from "components/Breadcrumb";
import BodyButton from "components/Buttons/BodyButton";
import CardHeader from "components/Card/CardHeader";

// import stylesheet
import Style from "./fastfacts.module.css";
import { RedirectToExternal } from "components/Heading";

import brochure from '../../assets/images/brochure.pdf'

// React functional component starts here..
function Product() {
  // initialized dispatch using react hook
  const dispatch = useDispatch();

  // react layout hook to perform initial layout operations
  useLayoutEffect(() => {
    // dispatching an action to update breadcrumb
    dispatch(addCrumb([{ link: "/fast-facts", name: "Fast Facts" }]));
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Get width from util
  const { width } = useWindowDimensions();

  return (
    <Container className={classNames("content")}>
      <BreadCrumb />
      <Row className="mt-5">
        <Col lg={6} className={classNames("")}>
          <CardHeader image={card_header_img} title="SureThing Cover" />
        </Col>
        <Col lg={3} className={Style.money}>
          <div className={Style.money}>
            From: <span>ZAR 225 pm</span>
          </div>
        </Col>
        <Col className={Style.fbutton}>
          <BodyButton
            color="white"
            bg="black"
            name="Get Cover Now"
            size={16}
            marginL={0}
            weight={700}
            marginT={width > 770 ? 0 : 20}
            black={width > 770 ? false : true}
            link="/forms"
          />
        </Col>
      </Row>
      <Row className={classNames(Style.topcard, "mt-4 px-2")}>
        {productDet?.map((det, i) => (
          <div key={i} className={classNames("mt-4")}>
            <H3Red>{det.header}</H3Red>
            {Array.isArray(det.content) ? (
              <div className={classNames("mt-4")}>
                <ul>
                  {det.content.map(({ title, answer, subAnswer }, i) => (
                    <li key={i}>
                      <H4Grey style={{ fontFamily: "var(--secondary-font)" }}>
                        {title}:{" "}
                      </H4Grey>
                      <span>{answer}</span>
                      {subAnswer?.map((ans, i) => (
                        <div
                          key={i}
                          className={classNames(Style.content__answer)}
                        >
                          - {ans}
                        </div>
                      ))}
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <div>{det.content}</div>
            )}
          </div>
        ))}
        <div className={classNames("my-4 d-flex justify-content-between")}>
        <RedirectToExternal target="_blank" style={{ color: 'black', fontWeight: 800}} href={brochure} >[ Download brochure ]</RedirectToExternal>
          <div>
            <img src={hollard_white} alt="Hollard." />
            <div>
              Hollard is an authorised
              <br /> Financial Services Provider, FSP no. 17698
            </div>
          </div>
        </div>
      </Row>

      <Row className="mt-2">
        <Accordion title={accordion2Data?.header}>
          {accordion2Data?.section?.map(({ header, content }, i) => (
            <div key={i}>
              <div className={classNames(Style.accordion2__header)}>
                {header}
              </div>
              <ul>
                {content?.map(({ title, answer, subAnswer }, i) => (
                  <li key={i}>
                    <div className={classNames(Style.content__header)}>
                      {" "}
                      {title}
                    </div>
                    <div className={classNames(Style.content__answer)}>
                      {answer}
                    </div>
                    {subAnswer?.map((ans, i) => (
                      <div
                        key={i}
                        className={classNames(Style.content__answer)}
                      >
                        - {ans}
                      </div>
                    ))}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </Accordion>
      </Row>
      <Row className="mt-5 align-items-center">
        <Col lg={4} className={(Style.money, "justify-content-start")}>
          <div className={classNames(Style.money, "justify-content-start")}>
            From: <span>ZAR 225 pm</span>
          </div>
        </Col>
        <Col className={classNames(Style.fbutton, "justify-content-start")}>
          <BodyButton
            color="white"
            bg="black"
            name="Get Cover Now"
            size={16}
            marginL={0}
            weight={700}
            marginT={width > 770 ? 0 : 20}
            black={width > 770 ? false : true}
            link="/forms"
          />
        </Col>
      </Row>
    </Container>
  );
}

export default Product;
